const $body = $(document.body);
const $site = $('.site', $body);

/*
 * with placeholder attribute and label--placeholder-helper
 */
const $floatingLabelInput = $('.js_floating-label-input', $site);

setTimeout(function () {
  $floatingLabelInput.each(function () {
    const self = $(this);
    hasValueHelperAction(self);

  });
}, 10);

$(document).on('focus', '.js_floating-label-input', function() {
  const self = $(this);
  addRightPadding(self);
  self.parent().addClass('is_focus');
}).on('blur', '.js_floating-label-input', function () {
  const self = $(this);
  hasValueHelperAction(self);
  self.parent().removeClass('is_focus');
});

/*
 * Placeholder helper Action after checking value
 */
function hasValueHelperAction(self) {
  //var valueCheck = checkHasValue(self);
  if ( self.val().length !== 0 ) {
    self.addClass('has_value');
    addRightPadding(self);
  } else {
    self.removeClass('has_value');
    self.removeAttr('style');
  }
}

/*
 * Placeholder Action after checking value without adding padding-right
 */
function hasValueAction(self) {
  const valueCheck = checkHasValue(self);
  if ( valueCheck == true ) {
    self.addClass('has_value');
  } else {
    self.removeClass('has_value');
  }
}

/*
 * check value
 */
function checkHasValue(self) {
  if (self.val().length !== 0) {
    return true;
  } else {
    return false;
  }
}

/*
 * add padding-right for label--placeholder-helper width
 */
function addRightPadding(self) {
  if ( !self.parent().hasClass('js_textarea-floating-label-control')) {
    const placeholderWidth = self.next().innerWidth();
    self.css('padding-right', placeholderWidth + 15 + 'px');
  }

}
